import { Link } from "react-router-dom";
import { Icon } from "@/components/layout/Icon";

/** Shown when a route's module is switched off by Feature Toggle Management
 * - distinct from AccessDenied (a permission problem): this is "the module
 * itself isn't available", which only a Super Admin (or, for the Expense
 * module's own switch, the Tenant Admin) can change - not a role issue the
 * signed-in user's own admin can fix by reassigning a permission. */
export function FeatureUnavailable() {
  return (
    <div className="flex h-[70vh] flex-col items-center justify-center text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-600">
        <Icon name="sliders" className="h-7 w-7" />
      </div>
      <h1 className="mt-4 text-xl font-semibold text-slate-900">Feature Unavailable</h1>
      <p className="mt-1 max-w-sm text-sm text-slate-500">
        This feature is not enabled for your organisation. Contact your platform administrator if you believe this is
        a mistake.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
